function Projects()
{
    return(
        <section id="projects">
            <h2>Project</h2>
            <div>
                <h2>Wordpress Portfolio</h2>
                <p>Created personal Portfolio in Wordpress site in Elementor and Custom CSS</p>
                <p><strong>Tech:</strong>Wordpress,Elementor,CSS</p>
            </div>
            <div>
                <h2>React Portfolio</h2>
                <p>Created personal Portfolio in React js, create bakery website in Bootstrap</p>
                <p><strong>Tech:</strong>React,Bootstrap</p>
            </div>
        </section>
    );
}export default Projects;